import * as Yup from "yup";
import checkout from "./form";

const {
  formField: {
    taxCalculationPeriod,
    ariseTimes,
    date,
    firstTime,
    supplementaryForThe,
    checkbox1,
    checkbox2,
    taxId1,
    taxpayerName,
    taxpayerName2,
    taxId2,
    address,
    address2,
    district,
    province,
    phone,
    fax,
    email,
    taxAgencyName,
    taxAgencyId,
    certificate,
    signer,
    fullName,
    timeSign,
  },
} = checkout;

const validation = Yup.object().shape({
  [fullName.name]: Yup.string().required(fullName.errorMsg),
  [timeSign.name]: Yup.number().required(timeSign.errorMsg),
  [certificate.name]: Yup.string().required(certificate.errorMsg),
  [signer.name]: Yup.string().required(signer.errorMsg),
  [address.name]: Yup.string().required(address.errorMsg),
  [address2.name]: Yup.string().required(address2.errorMsg),
  [district.name]: Yup.string().required(district.errorMsg),
  [province.name]: Yup.string().required(province.errorMsg),
  [email.name]: Yup.string().required(email.errorMsg).email(email.invalidMsg),
  [fax.name]: Yup.string().optional(),
  [firstTime.name]: Yup.string().required(firstTime.errorMsg),
  [checkbox1.name]: Yup.string().required(checkbox1.errorMsg),
  [checkbox2.name]: Yup.string().required(checkbox2.errorMsg),
  [phone.name]: Yup.string()
    .matches(/^(?:\+?84|0)(\d{9,10})$/, phone.invalidMsg)
    .required(phone.errorMsg),
  [supplementaryForThe.name]: Yup.string()
    .matches(/^\d+$/, supplementaryForThe.invalidMsg)
    .required(supplementaryForThe.errorMsg),
  [taxAgencyId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxAgencyId.invalidMsg)
    .required(taxAgencyId.errorMsg),
  [taxAgencyName.name]: Yup.string().optional(),
  [taxCalculationPeriod.name]: Yup.number().required(taxCalculationPeriod.errorMsg),
  [taxId1.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId1.invalidMsg)
    .required(taxId1.errorMsg),
  [taxId2.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId2.invalidMsg)
    .required(taxId2.errorMsg),
  [taxpayerName.name]: Yup.string().required(taxpayerName.errorMsg),
  [taxpayerName2.name]: Yup.string().required(taxpayerName2.errorMsg),
  [ariseTimes.name]: Yup.number().required(ariseTimes.errorMsg),
  [date.name]: Yup.number().required(date.errorMsg),
});

export default validation;
